module.exports = __webpack_public_path__ + "img/bsidd-1.00bb58c4.jpg";